module.exports = require("rc-tree/assets/index.css");